import MenuCardano from "src/components/Menu/cardano";
import MobileMenuCardano from "src/components/MobileMenu/cardano";

export default function Menu() {
  return (
    <>
      <MenuCardano></MenuCardano>
      <MobileMenuCardano></MobileMenuCardano>
    </>
  );
}
